import { gql } from '@apollo/client';

export const GET_WORK_PROGRESS_CLIENT_CARTONS = gql`
  query GetWorkProgressClientCartons($filter: WorkProgressBagDetailFilterInput!) {
    getWorkProgressBagDetails(filter: $filter) {
      items {
        id
        bigBagNo
        masterWaybillNo
        channelName
        arrivePortCode
        scanStatus
        scanType
        scanPort
        parcelCount
        onlineParcelCount
        offlineParcelCount
        createdAt
        scanTime
        earliestInboundDate
      }
      totalCount
    }
  }
`;

export interface WorkProgressClientCartonListItem {
  id: number;
  bigBagNo: string;
  masterWaybillNo: string | null;
  channelName: string | null;
  arrivePortCode: string | null;
  scanStatus: number;
  scanType: number | null;
  scanPort: string | null;
  parcelCount: number;
  onlineParcelCount: number;
  offlineParcelCount: number;
  createdAt: string | null;
  scanTime: string | null;
  /** 提单号下首个大包入库日期（YYYY-MM-DD）；client_carton 直接路径不附加，为 null */
  earliestInboundDate: string | null;
}

export interface WorkProgressClientCartonListResult {
  items: WorkProgressClientCartonListItem[];
  totalCount: number;
}

export interface GetWorkProgressClientCartonsResponse {
  getWorkProgressBagDetails: WorkProgressClientCartonListResult;
}

export interface WorkProgressBagDetailFilterInput {
  hubId: number;
  /** 大包差异 tab 下钻专用：非空时后端按 pre_pickup_hub_id 过滤、忽略 hubId；为空时按 hub_id 过滤（包裹差异口径） */
  prePickupHubId?: number | null;
  arrivalDateStart: string;
  arrivalDateEnd: string;
  /** 与主表客户筛选一致时传入；解析大包号集合时按 isInbound 过滤（显式 bigBagNo 单包下钻时后端忽略） */
  customerId?: number | null;
  /** 提单号 MAWB（与后端 filter.mawb 一致） */
  mawb?: string | null;
  bigBagNo?: string | null;
  /** 未传 mawb、bigBagNo 时的默认大包类型（一般为 1） */
  bagType?: number | null;
  /** false=仅未入库，true=仅已入库；不传/null 时后端不拼 is_inbound 条件 */
  isInbound?: boolean | null;
  /** true：仅查询已入库大包口径 */
  inboundBagOnly?: boolean | null;
  page?: number;
  pageSize?: number;
}

